<div id="login" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">

    <div id="login-intro" fxFlex fxHide fxShow.gt-xs>

        <div class="logo" [@animate]="{value:'*',params:{scale:'0.2'}}">
            <img src="/assets/images/logos/Group.svg">
        </div>

        <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}">
            Streamline Your HR Processes with Us
        </div>

        <div class="description" [@animate]="{value:'*',params:{delay:'100ms',y:'25px'}}">
        </div>

    </div>

    <div id="login-form-wrapper" fusePerfectScrollbar [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}">

        <div id="login-form">

            <div class="logo" fxHide.gt-xs>
                <img src="/assets/images/logos/Group.svg">
            </div>

            <div class="title">LOGIN TO YOUR ACCOUNT</div>

            <form name="loginForm" [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>

                <mat-form-field appearance="outline">
                    <mat-label>User Name</mat-label>
                    <input matInput formControlName="mobileno">
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error *ngIf="loginForm.get('mobileno').hasError('required')">
                        User Name is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Password</mat-label>
                    <input matInput type="password" formControlName="password">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error>
                        Password is required
                    </mat-error>
                </mat-form-field>

                <div class="remember-forgot-password" fxLayout="row" fxLayout.xs="column"
                    fxLayoutAlign="space-between center">
                    <mat-checkbox class="remember-me" aria-label="Remember Me" formControlName="rememberme">
                        Remember Me
                    </mat-checkbox>

                    <a class="forgot-password" [routerLink]="" (click)="openForgetPasswordPopup()">
                        Forgot Password?
                    </a>
                </div>

                <button mat-raised-button color="accent" class="submit-button" aria-label="LOGIN"
                    [disabled]="loginForm.invalid">
                    LOGIN
                </button>

            </form>
            <!-- <div style="width: 320px;">

                <div class="separator">
                    <span class="text">OR</span>
                </div>

                <div fxLayout="column" fxLayoutAlign="start center">

                    <button mat-raised-button class="google">
                        Log in with Google
                    </button>

                    <button mat-raised-button class="facebook">
                        Log in with Facebook
                    </button>

                </div>

                <div class="register" fxLayout="column" fxLayoutAlign="center center">
                    <span class="text">Don't have an account?</span>
                    <a class="link" [routerLink]="'/authorization/sign-up'">Create an account</a>
                </div>
            </div> -->
        </div>
            <mat-toolbar class="mat-footer">
                <div fxLayout="row"  style="display: flex; justify-content: end;"  fxFlex>
                    <a href="https://weblancertechnologies.com/" style=" border-radius: 10px;"
                        target="_blank" mat-button fxFlex="0 0 auto" fxLayout="row-reverse" fxLayoutAlign="start end" class="vTech">
                        <span style="font-weight: 1000; display: flex;"><h5 style="color: #039be5; background-color:transparent;">powered by:</h5>&nbsp;&nbsp;<span style="color: black;">WEBLANCER TECHNOLOGIES PVT. LTD.</span></span>
                    </a>
                </div>
            </mat-toolbar>
    </div>
</div>



<p-dialog [(visible)]="forgetPasswordDialog" [style]="{width: '450px'}" header="Forgot Password?" [modal]="true" class="custom-forgetPassword-dialog"
    [closeOnEscape]="false" (onHide)="hideForgetPasswordDialog()" styleClass="p-fluid">

    <ng-template pTemplate="content">
        <form #forgetPasswordForm="ngForm" (ngSubmit)="forgetPasswordForm.form.valid && SendResetLink()">

            <div class="p-field ">
                <label for="mobileNo">Mobile no.</label><span class="p-pl-1 p-error">*</span>
                <span class="p-input-icon-right">
                    <i class="pi pi-user"></i>
                    <input type="text" pInputText id="name" [(ngModel)]="userName" [required]="!mailsuccessfully" (ngModelChange)="inValidUsername = false"
                        autofocus placeholder="Mobile no." #mobileNo="ngModel" name="mobileNo" />
                </span>
                <small *ngIf="forgetPasswordForm.submitted &&  mobileNo.errors?.required && !mailsuccessfully"
                    class="p-error">Mobile number is
                    required.</small>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <button pButton pRipple type="button" type="submit" label="Send Reset Link"
                        class="p-button-raised Send-reset-link" [disabled]="mailsuccessfully"></button>
                </div>
            </div>

            <div class="p-field" *ngIf="mailsuccessfully">

                <p-messages severity="success" class="DemoClass">
                    <ng-template pTemplate>
                        <div class="p-ml-2">Reset password link sent successFully. Please check your registered email on
                            our system. </div>
                    </ng-template>
                </p-messages>
            </div>
            <div class="p-field custom-invaid-dialog" *ngIf="inValidUsername" >

                <p-messages severity="error">
                    <ng-template pTemplate>
                        <div class="p-ml-2">{{invalid}}</div>
                    </ng-template>
                </p-messages>
            </div>
        </form>
    </ng-template>
</p-dialog>
<p-dialog [(visible)]="resetPasswordDialog" [style]="{width: '450px'}" header="Reset Password" [modal]="true"
    [closable]="false" [closeOnEscape]="false" styleClass="p-fluid">

    <ng-template pTemplate="content">
        <form #ResetPasswordForm="ngForm"
            (ngSubmit)="confirmnewpassword == resetPasswordInputDto.password && ResetPasswordForm.form.valid && ResetPassword()">

            <div class="p-field">
                <label for="password"> New Password</label><span class="p-pl-1 p-error">*</span>
                <p-password id="pass" name="pass" required autofocus #pass="ngModel" [feedback]=false
                    [indicator]="false" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*[0-9]).{8,30}$"
                    [(ngModel)]="resetPasswordInputDto.password" [toggleMask]="true"></p-password>
                <small *ngIf="(pass.touched || pass.dirty || ResetPasswordForm.submitted) &&  pass.errors?.required"
                    class="p-error">New Password is required.
                </small>
                <small
                    *ngIf="(pass.touched || pass.dirty || ResetPasswordForm.submitted) && !pass.errors?.required && pass.errors?.pattern"
                    class="p-error">Password must be 8-30 characters long, include uppercase, lowercase, and special characters, and must not contain numbers.
                </small>
            </div>
            <div class="p-field">
                <label for="confirmPassword">Confirm Password </label><span class="p-pl-1 p-error">*</span>
                <p-password id="confirmpass" name="confirmPass" required autofocus #confirmPass="ngModel"
                    [feedback]="false" [indicator]="false" [(ngModel)]="confirmnewpassword" [toggleMask]="true">
                </p-password>
                <small class="p-error"
                    *ngIf="(confirmPass.touched || confirmPass.dirty || ResetPasswordForm.submitted) &&  confirmPass.errors?.required">Confirm
                    Password is required.</small>
                <small class="p-error"
                    *ngIf="(confirmPass.touched || confirmPass.dirty || ResetPasswordForm.submitted) && !confirmPass.errors?.required && confirmnewpassword !== resetPasswordInputDto.password">
                    New Password and Confirm Password must be same.
                </small>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <button pButton pRipple label="Cancel" icon="pi pi-times"
                        class="p-button-text parent-custom-button  p-button-danger" type="button"
                        (click)="hideDialog()"></button>
                    <button pButton pRipple label="Save" icon="pi pi-check" [disabled]="!ResetPasswordForm.form.valid"
                        class="p-button-text parent-custom-button " type="submit"></button>

                </div>
            </div>
        </form>
    </ng-template>
</p-dialog>
<p-dialog [(visible)]="inValidVerificationCode"  header="Info" [style]="{width: '450px'}" [modal]="true" [closable]="true" class="custom-invaid-dialog" (onHide)="hideInvalidPopup()"
    [closeOnEscape]="false" styleClass="p-fluid">


        <p-messages [severity]="severity">
            <ng-template pTemplate>
                <div>{{msg}} </div>
            </ng-template>
        </p-messages>
   
</p-dialog>